import { render, staticRenderFns } from "./DocumentRows.vue?vue&type=template&id=6dc60988"
import script from "./DocumentRows.vue?vue&type=script&lang=js"
export * from "./DocumentRows.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports